import React from 'react';

export default function VerificationBanner({ user }) {
  if (!user || user.status !== 'pending') return null;
  return (
    <div className="verification-banner" role="status" aria-live="polite">
      <div className="verification-banner-inner">
        <span className="verification-banner-icon" aria-hidden="true">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 9v4" />
            <path d="M12 17h.01" />
            <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
          </svg>
        </span>
        <div className="verification-banner-text">
          <strong>Awaiting Admin Verification</strong>
          <span>Your account is pending review. EA uploads, deployments, and your MT5 container unlock once an admin verifies you.</span>
        </div>
      </div>
    </div>
  );
}
